export const toNumber = (valor) => {
  const num = Number(valor)
  return Number.isFinite(num) ? num : 0
}

export const obtenerPrecioUnitarioMayorista = (item, cantidad) => {
  const cantidadEfectiva = toNumber(cantidad ?? item.cantidad)

  const tiersValidos = Array.isArray(item.preciosMayoristas)
    ? item.preciosMayoristas
        .map((p) => ({
          cantidad: toNumber(p.cantidad),
          precioUnitario: toNumber(p.precioUnitario ?? p.precio)
        }))
        .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)
        .sort((a, b) => b.cantidad - a.cantidad)
    : []

  if (tiersValidos.length > 0) {
    const tier = tiersValidos.find((p) => cantidadEfectiva >= p.cantidad)
    if (tier) return tier.precioUnitario
  }

  return toNumber(item.precioUnitario) || toNumber(item.precioUnitarioSinDescuento) || 0
}

export const calcularTotalItemSinIva = (item) => {
  const precioUnitario = obtenerPrecioUnitarioMayorista(item)
  const porcDcto = toNumber(item.porcDcto)
  const factorDescuento = porcDcto > 0 && porcDcto < 100 ? 1 - porcDcto / 100 : 1
  const cantidad = toNumber(item.cantidad) || 1
  return precioUnitario * factorDescuento * cantidad
}

export const calcularTotalItemConIva = (item) => {
  const alicuota = toNumber(item?.alicuota)
  return calcularTotalItemSinIva(item) * (1 + alicuota / 100)
}

export const esMayorista = (item) => {
  let lista = []
  if (Array.isArray(item?.preciosMayoristas) && item.preciosMayoristas.length > 0) {
    lista = item.preciosMayoristas
  } else if (Array.isArray(item?.preciosMayorista) && item.preciosMayorista.length > 0) {
    lista = item.preciosMayorista
  } else if (item?.precioUnitarioMayorista && item?.cantidadMayorista) {
    lista = [
      {
        cantidad: item.cantidadMayorista,
        precioUnitario: item.precioUnitarioMayorista
      }
    ]
  }

  const tiersValidos = lista
    .map((p) => ({
      cantidad: toNumber(p.cantidad),
      precioUnitario: toNumber(p.precioUnitario)
    }))
    .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)

  if (tiersValidos.length === 0) {
    return null
  }

  const aplicables = tiersValidos.filter((tier) => item.cantidad >= tier.cantidad)
  if (aplicables.length === 0) {
    return null
  }

  return aplicables.reduce((prev, curr) => (curr.cantidad > prev.cantidad ? curr : prev))
}

export const valorUnitarioSinIva = (item) => {
  const mayorista = esMayorista(item)

  if (mayorista) {
    return mayorista.precioUnitario
  }

  const unitario = toNumber(item.precioUnitario)
  if (unitario > 0) {
    return unitario
  }

  const totalConIva = toNumber(item.valorTotalConIva)
  const cant = toNumber(item.cantidad) || 1
  return cant > 0 ? totalConIva / cant : 0
}
